import { Row,Col, Container } from 'react-bootstrap'
import './contact.css'
import {Github, Linkedin, Twitter, Whatsapp} from 'react-bootstrap-icons'

const Contact = () => {
  return (
    <div className="contact ">
       <Container className='text-center justify-content-center align-items-center '>
            <Row>
                <Col>
                    <h3 className='main-color text-center under p-5'>Contact Us</h3>
                </Col>
            </Row>
            <Row>
                <Col sm={6} lg={4}>
                    <h2 className='main-color fw-bolder'>Call Me</h2>
                    <p className='text-white lead'>+2349063371705</p>
                </Col>
                <Col sm={6} lg={4}>
                    <h2 className='main-color fw-bolder'>Email</h2>
                    <p className='text-white lead'>femiblessing02@gmail.com</p>
                </Col>
                <Col sm={6} lg={4}>
                    <h2 className='main-color fw-bolder'>Location</h2>
                    <p className='text-white lead'>Lagos, Nigeria</p>
                </Col>
            </Row>
            <Row className='p-5'>
                <Col>
                    <div className="social-links">
                        <a href="https://github.com/Chaos10001">
                            <Github className='text-white h1 me-4 hov'/>
                        </a>
                        {/* <a href="https://www.linkedin.com/in/gabriel-femi-0750a3258">
                            <Linkedin className='text-white h1 me-5 hov'/>
                        </a> */}
                        <a href="https://twitter.com/Chaos00012?t=P3jNF_qhBs79-n4hjZd6rg&s=09">
                            <Twitter className='text-white h1 me-4 hov'/>
                        </a>
                        <a href="https://wa.link/u90eyv">
                            <Whatsapp className='text-white h1  hov'/>
                        </a>
                    </div>
                </Col>
            </Row>
       </Container>
    </div>
  )
}

export default Contact